import { SmartTable } from '@certemy/ui-components';
import { SubscriptionsListCustomFilter } from 'features/subscriptions/subscriptions.interface';

export enum SEVERITY_VALUES {
  'No Change' = 0,
  'Minor Change' = 1,
  'Major Change' = 2,
  'Critical Change' = 3,
}

export const DUE_DATE_RANGE_DEFAULT_VALUE = {
  date: {
    from: '',
    to: '',
  },
};

export const DEFAULT_SUBSCRIPTIONS_LISTS_SMART_FILTERS: SubscriptionsListCustomFilter = {
  statusId: null,
};

export const DefaultSubscriptionsListFilter = {
  filters: null,
  orderId: 'publishDate',
  orderType: SmartTable.Order.DESC,
  offset: 0,
  limit: 10,
  search: '',
};
